import { render, staticRenderFns } from "./CalendarMain.vue?vue&type=template&id=2bce6c5f"
import script from "./CalendarMain.vue?vue&type=script&lang=js"
export * from "./CalendarMain.vue?vue&type=script&lang=js"
import style0 from "./CalendarMain.vue?vue&type=style&index=0&id=2bce6c5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports